import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoVisaPassport24 = t0 => {
  const $ = _c(10);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  if ($[2] !== iconColor) {
    t2 = <path d="M9.91667 15.3334H14.0833M6.58333 19.0834H17.4167C17.8769 19.0834 18.25 18.7103 18.25 18.25V5.75002C18.25 5.28979 17.8769 4.91669 17.4167 4.91669H6.58333C6.1231 4.91669 5.75 5.28979 5.75 5.75002V18.25C5.75 18.7103 6.1231 19.0834 6.58333 19.0834Z" stroke={iconColor} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M12.0919 7.75884L12.6784 8.66282L13.7192 8.38351L13.5875 9.45303L14.5643 9.90807L13.7759 10.6427L14.2317 11.6192L13.1555 11.6751L12.877 12.7161L12.0167 12.0673L11.1342 12.6857L10.8922 11.6356L9.81865 11.5421L10.3082 10.5822L9.54596 9.82048L10.5381 9.39981L10.4437 8.32634L11.4741 8.6418L12.0919 7.75884Z" stroke={iconColor} strokeWidth={1.25} strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2 || $[8] !== t3) {
    t4 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default IcoVisaPassport24;